<template>
  <div>
    <Head title="International Suppliers" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/suppliers">International Suppliers</Link>
      <span class="text-orange-400 font-medium">/</span> Edit
    </h1>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <p> <strong>Contact Details</strong> </p>
        </div>
        <hr  class="mt-2 pb-1 pr-6 w-full lg:w-full" />
        <div class="flex flex-wrap -mb-16 -mr-6 p-8">
          <text-input v-model="form.name" type="text" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.address" type="address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Address" />
        </div>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <p><strong> Region</strong> </p>
        </div>
        <hr  class="mt-2 pb-1 pr-6 w-full lg:w-full" />
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.country_id"
            :error="form.errors.country_id"
            class="pb-2 pr-6 w-full lg:w-1/2"
            label="Country"
          >
            <option :value="null">
              Select the Country
            </option>
            <option
              v-for="country in countries"
              :key="country.id"
              :value="country.id"
            >
              {{ country.name }}
            </option>
          </select-input>
        </div>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <p><strong> Lead Time</strong> </p>
        </div>
        <hr  class="mt-2 pb-1 pr-6 w-full lg:w-full" />
        <div class="flex flex-wrap -mb-16 -mr-6 p-8">
          <text-input v-model="form.shipment_time" type="text" :error="form.errors.shipment_time" class="pb-8 pr-6 w-full lg:w-1/2" label="Shipment Time (Days)" />
        </div>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <p><strong> Payment Terms</strong> </p>
        </div>
        <hr  class="mt-2 pb-1 pr-6 w-full lg:w-full" />
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.category"
            :error="form.errors.category"
            class="pb-2 pr-6 w-full lg:w-1/2"
            label="Category"
            @change="selected"
          >
            <option :value="null">
              Select the Category
            </option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select-input>
          <text-input v-show ="form.category === 'category-1'" v-model="form.on_order_placement" type="text" :error="form.errors.on_order_placement" class="pb-8 pr-6 w-full lg:w-1/2" label="On Order" />
          <text-input v-show ="form.category === 'category-2'" v-model="form.on_order_placement" type="text" :error="form.errors.on_order_placement" class="pb-8 pr-6 w-full lg:w-1/2" label="On Order" />
          <text-input v-show ="form.category === 'category-3'" v-model="form.on_order_placement" type="text" :error="form.errors.on_order_placement" class="pb-8 pr-6 w-full lg:w-1/2 hidden" label="100% On Order" />
          <text-input v-show ="form.category === 'category-4'" v-model="form.on_order_placement" type="text" :error="form.errors.on_order_placement" class="pb-8 pr-6 w-full lg:w-1/2" label="Days from BL date" />
        </div>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <p><strong>Incoterms</strong> </p>
        </div>
        <hr  class="mt-2 pb-1 pr-6 w-full lg:w-full" />
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.incoterm"
            :error="form.errors.incoterm"
            class="pb-2 pr-6 w-full lg:w-1/2"
            label="Incoterms"
          >
            <option :value="null">
              Select the Incoterms
            </option>
            <option
              v-for="incoterm in incoterms"
              :key="incoterm.id"
              :value="incoterm.id"
            >
              {{ incoterm.name }}
            </option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Update Supplier</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    countries: Array,
    supplier: Array,
    incoterms: Array,
    categories: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.supplier.name,
        country_id: this.supplier.country_id,
        address: this.supplier.address,
        category: this.supplier.category,
        incoterm: this.supplier.incoterm,
        shipment_time: this.supplier.shipment_time,
        on_order_placement: this.supplier.on_order_placement,
        in_exchange_of_bl: this.supplier.in_exchange_of_bl,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/suppliers/${this.supplier.id}`)
    },
  },
}
</script>
